var $d80a27deda7cdb3c$exports = {};
$d80a27deda7cdb3c$exports = {
    "dismiss": `\u{53D6}\u{6D88}`
};


export {$d80a27deda7cdb3c$exports as default};
//# sourceMappingURL=zh-CN.mjs.map
